import React from 'react';
import PropTypes from 'prop-types';

import StatisticLogger from '@wix/wix-vod-shared/src/widget/vod-player/components/loggers/statistic-logger';
import ErrorLogger from '@wix/wix-vod-shared/src/widget/vod-player/components/loggers/error-logger';
import PlaybackSuccessLogger from '@wix/wix-vod-shared/src/widget/vod-player/components/loggers/playback-success-logger';

import bi from 'shared/bi/bi';


class Loggers extends React.Component {

  static propTypes = {
    isEmbed: PropTypes.bool,
    engine: PropTypes.object,
    eventEmitter: PropTypes.object,
    channelData: PropTypes.object,
    videoItem: PropTypes.object,
    isVideoPlaying: PropTypes.bool,
    isLive: PropTypes.bool,
  };

  static defaultProps = {
    isEmbed: false,
    isLive: false,
  }

  logPlaybackTry(data) {
    bi.log('player-play-requested', data);
  }

  logPlaybackSuccess(data) {
    bi.log('player-play-done', data);
  }

  logError(data) {
    bi.log('player-error', data);
  }

  logStatistic(data) {
    bi.log('player-debug-info', data);
  }

  render() {
    const { engine, eventEmitter, videoItem, channelData, isVideoPlaying, isEmbed, isLive } = this.props;

    return (
      <section>
        <StatisticLogger videoID={videoItem.id}
                         isEmbed={isEmbed}
                         isLive={isLive}
                         channelID={channelData.id}
                         engine={engine}
                         logFunction={this.logStatistic}
                         shouldSendBI={isVideoPlaying} />
        <PlaybackSuccessLogger videoID={videoItem.id}
                               engine={engine}
                               eventEmitter={eventEmitter}
                               logTryFunction={this.logPlaybackTry}
                               logSuccessFunction={this.logPlaybackSuccess}
                               channelID={channelData.id} />
        <ErrorLogger engine={engine}
                     eventEmitter={eventEmitter}
                     logFunction={this.logError}
                     videoID={videoItem.id}
                     isLive={isLive} />
      </section>
    );
  }
}

export default Loggers;



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/containers/loggers/loggers.js